import { render, staticRenderFns } from "./newusePowerDifference.vue?vue&type=template&id=18f6a1c0&scoped=true&"
import script from "./newusePowerDifference.vue?vue&type=script&lang=js&"
export * from "./newusePowerDifference.vue?vue&type=script&lang=js&"
import style0 from "./newusePowerDifference.vue?vue&type=style&index=0&id=18f6a1c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6a1c0",
  null
  
)

export default component.exports